import { Alert, Box, Container, SelectChangeEvent } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { useAppDispatch, useAppSelector } from "app/hooks";
import OutlinedButton from "components/buttons/OutlinedButton";
import Header from "components/header/Header";
import { AgentSelect } from "components/inputs/AgentSelect";
import HolzfinderInputLabled from "components/inputs/HolzfinderInputLabled";
import { HolzfinderTaxSelect } from "components/inputs/HolzfinderTaxSelect";
import { selectAgent } from "features/agent/agentSlice";
import { createSeller, selectAgentId, selectSellerNumber, selectTaxType, setAgentId, setSellerNumber, setTaxType } from "features/seller/newSellerSlice";
import { selectUserRole } from "features/user/userSlice";
import { UserRoles } from "interfaces/UserRoles";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import LotOfferButton from "../lotOffer/LotOfferButton";

const formFields = {
  seller_number: {
    label: "Betriebsnr.",
    placeholder: "Betriebsnr.",
    backendField: "eldat_reference_id",
  },
  agent_id: {
    label: "Agent-ID",
    placeholder: "Agent-ID",
    backendField: "agent_id",
  },
  taxation_kind_id: {
    label: "Besteuerungstyp",
    backendField: 'taxation_kind_id',
  },
}
const backendFields = Object.values(formFields).map(field => field.backendField);

export default function SellerAdd() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const userRole = useAppSelector(selectUserRole);
  const currentAgentId = useAppSelector(selectAgent)?.id;
  const sellerNumber = useAppSelector(selectSellerNumber);
  const taxType = useAppSelector(selectTaxType);
  const agentId = useAppSelector(selectAgentId);
  const [error, setError] = useState("");
  const [fieldErrors, setFieldErrors] = useState<Record<string, string[]>>({});

  useEffect(() => {
    if (userRole === UserRoles.Agent && currentAgentId) {
      dispatch(setAgentId(currentAgentId));
    }
  }, [dispatch, userRole, currentAgentId]);
  const handleSellerNumberChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setError(""); // Reset error on input change
    if (!/^\d*$/.test(event.target.value)) {
      setError("Nur numerische Zeichen sind erlaubt.");
      return;
    }
    dispatch(setSellerNumber(event.target.value));
  };
  const handleTaxTypeChange = (event: SelectChangeEvent<unknown>) => {
    setError(""); // Reset error on input change
    dispatch(setTaxType(event.target.value as string));
  };
  const handleUserRoleChange = (event: SelectChangeEvent<unknown>) => {
    setError(""); // Reset error on input change
    dispatch(setAgentId(event.target.value as string));
  };
  const saveChanges = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    dispatch(createSeller()).then((data: any) => {
      if (data.meta.requestStatus === "fulfilled") {
        navigate(`/${userRole}/verkaeuferliste/${data.payload.data.id}`, { replace: true });
      } else {
        const errors = data.payload as Record<string, string[]> | undefined;
        if (errors) {
          const extraErrors: Array<string> = [];
          Object.entries(errors).forEach(([key, value]: [string, Array<string>]) => {
            if (!backendFields.includes(key)) {
              extraErrors.push(`${key}: ${value.join(", ")}`);
            }
          });
          setError(extraErrors.join(", "));
          setFieldErrors(errors);
        } else {
          setError("An error occurred while saving changes.");
        }
      }
    });
  };

  return (
    <Container
      component="form"
      maxWidth="xl"
      sx={{
        pt: 4,
        pb: 4,
        pl: { lg: 12, md: 14, xs: 13 },
      }}
    >
      <Header backButton header="Verkäufer Stammdaten anlegen" />
      <Grid container spacing={2} sx={{ mb: 2, mt: 2 }}>
        <Grid xs={12} md={3}>
          <HolzfinderInputLabled
            id={"seller_number"}
            label={"Betriebsnr."}
            placeholder="Betriebsnr."
            value={sellerNumber}
            onInput={handleSellerNumberChange}
            error={!!fieldErrors.eldat_reference_id}
            helperText={fieldErrors.eldat_reference_id ? fieldErrors.eldat_reference_id.join(", ") : ""}
          />
        </Grid>
        <Grid xs={12} md={3}>
          <HolzfinderTaxSelect
            value={taxType}
            onChange={handleTaxTypeChange}
            error={!!fieldErrors.taxation_kind_id}
            helperText={fieldErrors.taxation_kind_id ? fieldErrors.taxation_kind_id.join(", ") : ""}
          />
        </Grid>
        {userRole === UserRoles.Admin && (
          <Grid xs={12} md={3}>
            <AgentSelect agentId={agentId} handleUserRoleChange={handleUserRoleChange} fieldErrors={fieldErrors} />
          </Grid>
        )}
        <Grid xs={12}>
          {error && <Alert severity="error">{error}</Alert>}
        </Grid>
      </Grid>
      <Box sx={{ mt: 2, display: "flex", gap: 1 }}>
        <LotOfferButton
          type="submit"
          label="Änderungen speichern"
          sx={{ borderRadius: "26px", height: "51px", fontWeight: "bold" }}
          onClick={saveChanges}
          disabled={error.length > 0}
        />
        <OutlinedButton onClick={() => { navigate(`/${userRole}/verkaeuferliste`) }}>
          Änderungen VERWERFEN
        </OutlinedButton>
      </Box>
    </Container>
  );
}